import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { actions } from '../../actions';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import CanvasUserTable from './CanvasUserTable';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: '10px',
        overflowX: 'auto',
    },
    table: {
        // minWidth: 700,
    },
    button: {
        margin: theme.spacing.unit,
    },
});

const AddedReviewers = (props) => {
    const onUserSelection = (unid) => {
        const selectedReviewerIndex = props.reviewers.map(canvasUser => canvasUser.unid).indexOf(unid);

        if (selectedReviewerIndex !== -1) {
            // remove from redux store
            const selectedCanvasUser = props.reviewers[selectedReviewerIndex];
            props.removeReviewer(selectedCanvasUser);
            // update found canvas users
            props.addCanvasUser(selectedCanvasUser);
        }
    };

    const didFoundReviewers = props.reviewers && props.reviewers.length > 0;
    let visible = null;

    if (didFoundReviewers) {
        visible = (
            <div>
                <CanvasUserTable hideRemove={props.hideRemove} users={props.reviewers} onUserSelection={onUserSelection}>
                    <IconButton className={props.classes.button} aria-label="Delete">
                        <DeleteIcon/>
                    </IconButton>
                </CanvasUserTable>
            </div>
        )
    }

    return (
        <div>
            {visible}
        </div>

    )

};

CanvasUserTable.propTypes = {
    canvasUsers: PropTypes.arrayOf(
        PropTypes.shape({
            unid: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired
        }).isRequired
    ),
    reviewers: PropTypes.arrayOf(
        PropTypes.shape({
            unid: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired
        }).isRequired
    )
};

function mapStateToProps (state) {
    return {
        reviewers: state.reviewers,
        canvasUsers: state.canvasUsers
    }
}

export default connect(mapStateToProps, actions)(withStyles(styles)(AddedReviewers));